import { act } from 'react-dom/test-utils';
import { delay } from '../components/utils';

export const actDelay = (time: number) =>
  act(async () => delay(time) as Promise<void>);

export const getFocus = () => document.querySelector(':focus');

export const repeatTest = (times: number, testFn: () => any) => {
  for (let i = 1; i <= times; i++) {
    testFn();
  }
};
